// Manually bumped when a release is declared — not tied to deploy count.
// Bump to v1.1, v1.2, etc. only when told this is a new release.
export const PRODUCT_VERSION = 'v1.0';
